import React from "react"
import Link from "components/atoms/Link/Link"
import PanelLayoutContent from "components/layout/PanelLayoutContent"
import { useProfileFeature } from "hooks/useProfile"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Outlet, useNavigate } from "react-router-dom"
import { RootState } from "store/store"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"

const Profile = () => {
  const navigate = useNavigate()
  const { t } = useTranslation(["panel", "common"])
  const { profile } = useSelector((state: RootState) => state.profile)
  const hasAIChat = useProfileFeature("ai_chat")

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm()

  return (
    <PanelLayoutContent icon="company" title={t("profile.title")} text={t("profile.text")}>
      <NavigationWrapper>
        <Link $type="secondary" to="/panel/profile" end>
          {t("profile.navigation.profile")}
        </Link>
        <Link $type="secondary" to="/panel/profile/surveys">
          {t("profile.navigation.surveys")}
        </Link>
        {hasAIChat && (
          <Link $type="secondary" to="/panel/profile/knowledge-base">
            {t("profile.navigation.knowledge-base")}
          </Link>
        )}
        <Link $type="secondary" to="/panel/profile/settings">
          {t("profile.navigation.settings")}
        </Link>
        <Link $type="secondary" to="/panel/profile/billing">
          {t("profile.navigation.billing")}
        </Link>
        <Link $type="secondary" to="/change-password">
          {t("profile.navigation.password")}
        </Link>
      </NavigationWrapper>
      <Outlet />
    </PanelLayoutContent>
  )
}

export default Profile

const NavigationWrapper = styled(Box)`
  display: flex;
  grid-gap: ${({ theme }) => theme.space.XS};
  margin-bottom: ${({ theme }) => theme.space.S};
`
